import React from 'react';
import cn from 'classnames';
import TraceTileHeader from '@/finsight/ui/components/trace/TraceTile/TraceTileHeader/TraceTileHeader';
import TraceTable from '@/finsight/ui/components/trace/common/TraceTable';
import ComposeTraceTileContext from '@/finsight/application/Trace/ComposeTraceTileContext';
import { useParentPageContext } from '@/finsight/application/ParentPageContext';
import { useTraceTileContext } from '@/finsight/application/Trace/TraceTileContext';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import { UserPlanType } from '@/users/domain/UserPlan';
import TraceChart from '@/finsight/ui/components/trace/TraceChart';
import TradesTab from './TradesTab';
import TraceChartContextProvider from '@/finsight/application/Trace/TraceChartContext';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import EmptyMessageWithLink from '@/finsight/ui/common/components/EmptyMessageWithLink';

import styles from '@/finsight/ui/components/trace/TraceTile/TraceTileHeader/traceTileHeader.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const TraceTile = ({ withChart = false }) => {
  const { isModuleEnabled } = useTraceTileContext();

  if (isModuleEnabled) {
    return (
      <div className={ cn(styles.container, spacesStyles.mtl) }>
        <CheckUserPlanAccess requiredUserPlan={ UserPlanType.PRO } fallback={ null }>
          { withChart && <TraceChart /> }
        </CheckUserPlanAccess>
        <TraceTileHeader withChart={ withChart } />
        <CheckUserPlanAccess requiredUserPlan={ UserPlanType.PRO } fallback={ null }>
          <>
            { withChart && <TradesTab /> }
            <TraceTable
              isItemsPerPageVisible={ false }
              emptyMessage={ (
                <EmptyMessageWithLink
                  text="Explore all other"
                  linkTo={ finsightWebUrl.getTraceUrl() }
                  linkTitle="TRACE"
                />
              ) }
            />
          </>
        </CheckUserPlanAccess>
      </div>
    );
  }

  return null;
};

interface IProps {
  withChart?: boolean,
}

export default ({ withChart }: IProps) => {
  const { traceTileData } = useParentPageContext();

  return (
    <ComposeTraceTileContext
      traceTileData={ traceTileData }
    >
      <TraceChartContextProvider withChart={ withChart }>
        <TraceTile withChart={ withChart } />
      </TraceChartContextProvider>
    </ComposeTraceTileContext>
  );
};
